import type { SVGProps } from "react";
export interface LocationHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LocationHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LocationHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 10c0-3.63-3.095-6.875-6.876-6.875-3.78 0-6.874 3.245-6.874 6.875v.547l.012.41c.118 2.039 1.107 3.997 2.41 5.712 1.383 1.817 3.037 3.25 4.085 4.07a.58.58 0 0 0 .737 0c1.048-.82 2.7-2.253 4.082-4.07 1.39-1.829 2.424-3.935 2.424-6.122zm2.25.547c0 2.884-1.348 5.467-2.882 7.484-1.543 2.029-3.36 3.599-4.487 4.481a2.834 2.834 0 0 1-3.511 0c-1.128-.882-2.944-2.452-4.487-4.48-1.439-1.892-2.713-4.28-2.867-6.947l-.016-.538V10c0-4.839 4.069-9.125 9.124-9.125 5.057 0 9.126 4.286 9.126 9.125z"
      />
      <path
        fill={color}
        d="M13.957 6.375c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.759 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.098l-.118-.098a75 75 0 0 1-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408c.543-.623 1.353-1.102 2.288-1.102.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.028.05-.022.04a1 1 0 0 1-.174.216 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.32-.015 1 1 0 0 1-.157-.038q-.003 0-.005-.002a1 1 0 0 1-.118-.048l-.061-.034-.022-.011a1.1 1.1 0 0 1-.213-.169 1.1 1.1 0 0 1-.178-.221l-.02-.04q-.016-.023-.027-.048l-.002-.001c-.097-.203-.2-.4-.357-.555-.128-.127-.295-.229-.589-.229-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075a74 74 0 0 0 1.853-1.743l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331"
      />
    </svg>
  );
}
